<template>
  <div>
    <div class="d-flex mb-8">
      <div class="titulo-pagina">
        {{ tituloFormulario }}
      </div>
    </div>
    <div style="min-height: 200px" class="mt-2">
      <v-form class="row mb-2" ref="form">
        <input-select
          v-model="form.participanteId"
          class="col-12 col-md-6"
          :options="opcoes.participantes"
          :label="$t('componentes.input_instrumento_padrao.participante')"
          obrigatorio
        />
        <input-instrumento
          v-model="form.instrumento"
          class="col-6"
          :label="$t('modulos.comunicacao_com_instrumento.titulo_modal')"
          :participanteId="form.participanteId"
          :disabled="!form.participanteId"
          :multiplos="false"
          :obrigatorio="true"
        />
        <input-select
          v-model="form.tipoComunicacao"
          :options="tipoEnvioMaterialFiltrado"
          :label="
            $t(
              'modulos.comunicacao_com_instrumento.formulario.tipo_comunicacao'
            )
          "
          :placeholder="$t('geral.inputs.selecione')"
          class="col-6"
          obrigatorio
        />
        <input-text
          v-model="form.baudRate"
          class="col-6"
          :label="$t('modulos.comunicacao_com_instrumento.formulario.baudrate')"
          type="number"
          obrigatorio
        />
        <input-text
          v-model="form.dataBits"
          class="col-6"
          :label="
            $t('modulos.comunicacao_com_instrumento.formulario.data_bits')
          "
          type="number"
          obrigatorio
        />
        <input-text
          v-model="form.parity"
          class="col-6"
          label="Parity"
          obrigatorio
        />
        <input-text
          v-model="form.stopBits"
          class="col-6"
          :label="$t('modulos.comunicacao_com_instrumento.formulario.stopbits')"
          type="number"
          obrigatorio
        />
      </v-form>
      <v-divider class="my-5" />
      <div class="d-flex align-center justify-end">
        <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
          <v-icon>$mdiCancel</v-icon>
          {{ $t('geral.botoes.cancelar') }}
        </botao-padrao>
        <botao-padrao @click="confirmacaoSalvar">
          <v-icon>$mdiContentSaveOutline</v-icon>
          {{ $t('geral.botoes.salvar') }}
        </botao-padrao>
      </div>
    </div>
  </div>
</template>
<script>
import InputInstrumento from './components/InputInstrumento.vue';
import ComunicacaoInstrumentoService from '@common/services/cadastros/ComunicacaoInstrumentoService';
import { ComunicacaoInstrumentoModel } from '@common/models/cadastros/ComunicacaoInstrumentoModel';
import helpers from '@common/utils/helpers';
import PermissaoService from '@common/services/cadastros/PermissaoService';

export default {
  components: {
    InputInstrumento,
  },
  props: {
    id: { type: String, default: '' },
  },
  data() {
    return {
      form: new ComunicacaoInstrumentoModel({}),
      tipoEnvioMaterialFiltrado: [{ value: 'Serial', text: 'Serial' }],
      opcoes: {
        participantes: [],
      },
      valido: false,
    };
  },
  computed: {
    tituloFormulario: function () {
      if (this.id)
        return this.$t('modulos.comunicacao_com_instrumento.titulos.editar');
      return this.$t('modulos.comunicacao_com_instrumento.titulos.novo');
    },
  },
  form: {
    handler() {
      this.$emit('form-comunicacao_com_instrumento', this.form);
    },
    immediate: true,
  },
  mounted() {
    this.listarParticipantes();

    if (this.id) {
      this.buscar(this.id);

      helpers.redirecionarSemPermissao(
        this,
        'ComunicacaoInstrumento',
        'Editar'
      );
    }
    helpers.redirecionarSemPermissao(this, 'ComunicacaoInstrumento', 'Inserir');

    this.buscarPermissoes();
    this.$store.dispatch('Layout/alterarTituloPagina', this.tituloFormulario);
  },
  methods: {
    listarParticipantes: function () {
      let { participantes } = this.$store.getters['Autenticacao/usuario'];
      this.opcoes.participantes = participantes;
    },
    async buscarPermissoes(paginaAtual = 1, porPagina = 9999) {
      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
      };
      await PermissaoService.listar(parametros).then((res) => {
        this.dadosPermissoes = res.data.items;
      });
    },
    confirmacaoSalvar: function () {
      this.confirmarSalvar().then(() => {
        if (this.id || !this.id) {
          this.form.instrumentoId = this.form.instrumento?.value;
        }
        this.salvar();
      });
    },
    salvar: function () {
      if (this.$refs.form) this.valido = this.$refs.form.validate();
      if (!this.valido) return;

      this.$store.dispatch('Layout/iniciarCarregamento');
      ComunicacaoInstrumentoService.salvar(this.form)
        .then(() => {
          this.$router.push({ name: 'comunicacao-com-instrumento' });
          this.toastSucesso(
            this.$t(`modulos.comunicacao_com_instrumento.cadastro_sucesso`)
          );
        })
        .catch((err) => {
          this.toastErro(this.$t(`geral.erros.${err.response.data.errors[0]}`));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
          this.valido = false;
        });
    },
    buscar: function () {
      this.$store.dispatch('Layout/iniciarCarregamento');
      ComunicacaoInstrumentoService.buscar(this.id)
        .then((res) => {
          this.form = new ComunicacaoInstrumentoModel(res.data);
          this.valido = true;

          this.form.instrumento = res.data.instrumento?.codigoTag;
          this.form.instrumentoId = res.data.instrumento?.id;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    cancelar: function () {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'comunicacao-com-instrumento' });
      });
    },
  },
};
</script>
